import React from "react";

import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./Common.module.scss";

interface Props {
  isSyncFailed: boolean;
}

const InfoIcon: React.FC<Props> = ({ isSyncFailed }) => {
  if (isSyncFailed) {
    return <FontAwesomeIcon className={styles.errorIcon} icon={faTimesCircle} />;
  }

  if (isSyncFailed) {
    return <FontAwesomeIcon className={styles.successIcon} icon={faCheckCircle} />;
  }

  return <FontAwesomeIcon className={styles.successIcon} icon={faCheckCircle} />;
};

export default InfoIcon;
